import { SourceType } from "../enums/SDKSourceType";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
const STORYBOOK_CLI_IMPORT_DESCRIPTION = "CLI";
var SourceRemoteType;
(function (SourceRemoteType) {
    SourceRemoteType["figma"] = "Figma";
    SourceRemoteType["tokenStudio"] = "TokenStudio";
    SourceRemoteType["figmaVariablesPlugin"] = "FigmaVariablesPlugin";
    SourceRemoteType["upload"] = "Upload";
    SourceRemoteType["storybook"] = "Storybook";
})(SourceRemoteType || (SourceRemoteType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class Source {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Getter & Setters
    get lastImportedAt() {
        var _a, _b, _c, _d;
        if ((_a = this.cloud) === null || _a === void 0 ? void 0 : _a.lastImportedAt) {
            return this.cloud.lastImportedAt;
        }
        if ((_b = this.tokenStudio) === null || _b === void 0 ? void 0 : _b.lastImportedAt) {
            return this.tokenStudio.lastImportedAt;
        }
        if ((_c = this.figmaVariablesPlugin) === null || _c === void 0 ? void 0 : _c.lastImportedAt) {
            return this.figmaVariablesPlugin.lastImportedAt;
        }
        if ((_d = this.storybook) === null || _d === void 0 ? void 0 : _d.lastImportedAt) {
            return this.storybook.lastImportedAt;
        }
        return null;
    }
    get hasError() {
        var _a, _b, _c;
        if (this.type === SourceType.storybook) {
            return (_b = (_a = this.storybook) === null || _a === void 0 ? void 0 : _a.isFailed) !== null && _b !== void 0 ? _b : false;
        }
        const lastImportResult = (_c = this.cloud) === null || _c === void 0 ? void 0 : _c.lastImportResult;
        const hasImportError = (lastImportResult === null || lastImportResult === void 0 ? void 0 : lastImportResult.isFailed) || !this.isCloudAvailable;
        if (Object.values(this.scope).every((value) => !value) && !hasImportError) {
            // we don't show error for scope-less source
            return false;
        }
        // If the import failed completely, it counts as an error
        return !lastImportResult || hasImportError;
    }
    get hasWarning() {
        var _a, _b;
        const lastImportResult = (_a = this.cloud) === null || _a === void 0 ? void 0 : _a.lastImportResult;
        if (!lastImportResult)
            return false;
        // Any error warnings count as an error
        if ((_b = lastImportResult.warnings) === null || _b === void 0 ? void 0 : _b.length)
            return true;
        return false;
    }
    get isCloudAvailable() {
        if (this.cloud) {
            return this.cloud.state === "Active";
        }
        return false;
    }
    get isTokensStudioAvailable() {
        return !!this.tokenStudio;
    }
    get tokensStudioHasError() {
        var _a;
        const lastImportedResults = (_a = this.tokenStudio) === null || _a === void 0 ? void 0 : _a.lastImportedResults;
        // Tokens studio source import results can not be null
        if (!lastImportedResults)
            return true;
        return lastImportedResults.some((result) => result.isFailed);
    }
    updateStorybookImportResult(update) {
        if (this.type !== SourceType.storybook || !this.storybook) {
            throw new Error("Cannot update storybook import result for non-storybook source");
        }
        this.storybook = Object.assign(Object.assign({}, this.storybook), { lastImportedAt: new Date(), lastImportedResult: {
                created: update.created.length,
                updated: update.updated.length,
                deleted: update.deleted.length,
            }, isFailed: update.isFailed });
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        this.type = sourceTypeFromRemote(model.type);
        this.id = model.id;
        this.fileName = (_a = model.fileName) !== null && _a !== void 0 ? _a : null;
        this.brandId = (_b = model.brandId) !== null && _b !== void 0 ? _b : null;
        this.themeId = (_c = model.themeId) !== null && _c !== void 0 ? _c : null;
        this.fileName = (_d = model.fileName) !== null && _d !== void 0 ? _d : null;
        if (model.cloud) {
            this.cloud = {
                fileId: (_f = (_e = model.cloud) === null || _e === void 0 ? void 0 : _e.fileId) !== null && _f !== void 0 ? _f : undefined,
                autoImportMode: (_h = (_g = model.cloud) === null || _g === void 0 ? void 0 : _g.autoImportMode) !== null && _h !== void 0 ? _h : null,
                // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
                fileThumbnailUrl: (_k = (_j = model.cloud) === null || _j === void 0 ? void 0 : _j.fileThumbnailUrl) !== null && _k !== void 0 ? _k : null,
                ownerId: (_m = (_l = model.cloud) === null || _l === void 0 ? void 0 : _l.ownerId) !== null && _m !== void 0 ? _m : null,
                ownerUserName: (_p = (_o = model.cloud) === null || _o === void 0 ? void 0 : _o.ownerUserName) !== null && _p !== void 0 ? _p : null,
                state: (_r = (_q = model.cloud) === null || _q === void 0 ? void 0 : _q.state) !== null && _r !== void 0 ? _r : null,
                stats: (_t = (_s = model.cloud) === null || _s === void 0 ? void 0 : _s.stats) !== null && _t !== void 0 ? _t : null,
                // @ts-expect-error TS(2322): Type 'Date | null' is not assignable to type 'Date... Remove this comment to see the full error message
                lastUpdatesCheckedAt: ((_u = model.cloud) === null || _u === void 0 ? void 0 : _u.lastUpdatesCheckedAt)
                    ? new Date(model.cloud.lastUpdatesCheckedAt)
                    : null,
                // @ts-expect-error TS(2322): Type 'Date | null' is not assignable to type 'Date... Remove this comment to see the full error message
                lastImportedAt: ((_v = model.cloud) === null || _v === void 0 ? void 0 : _v.lastImportedAt)
                    ? new Date(model.cloud.lastImportedAt)
                    : null,
                // @ts-expect-error TS(2322): Type '{ id: string; created_at: string; label: str... Remove this comment to see the full error message
                lastImportedVersion: ((_w = model.cloud) === null || _w === void 0 ? void 0 : _w.lastImportedVersion)
                    ? {
                        id: model.cloud.lastImportedVersion.id,
                        created_at: model.cloud.lastImportedVersion.created_at,
                        label: (_x = model.cloud.lastImportedVersion.label) !== null && _x !== void 0 ? _x : null,
                        description: model.cloud.lastImportedVersion.description,
                    }
                    : null,
                // @ts-expect-error TS(2322): Type '{ sourceId: string; brandId: string; tokensC... Remove this comment to see the full error message
                lastImportResult: ((_y = model.cloud) === null || _y === void 0 ? void 0 : _y.lastImportResult)
                    ? {
                        sourceId: model.cloud.lastImportResult.sourceId,
                        brandId: model.cloud.lastImportResult.brandId,
                        tokensCreated: model.cloud.lastImportResult.tokensCreated,
                        tokensUpdated: model.cloud.lastImportResult.tokensUpdated,
                        tokensDeleted: model.cloud.lastImportResult.tokensDeleted,
                        componentsCreated: model.cloud.lastImportResult.componentsCreated,
                        componentsUpdated: model.cloud.lastImportResult.componentsUpdated,
                        componentsDeleted: model.cloud.lastImportResult.componentsDeleted,
                        componentAssetsCreated: model.cloud.lastImportResult.componentAssetsCreated,
                        componentAssetsUpdated: model.cloud.lastImportResult.componentAssetsUpdated,
                        componentAssetsDeleted: model.cloud.lastImportResult.componentAssetsDeleted,
                        isFailed: model.cloud.lastImportResult.isFailed,
                        versionId: model.cloud.lastImportResult.versionId,
                        fileSize: (_z = model.cloud.lastImportResult.fileSize) !== null && _z !== void 0 ? _z : null,
                        warnings: (_0 = model.cloud.lastImportResult.warnings) !== null && _0 !== void 0 ? _0 : [],
                        isFramesFailed: model.cloud.lastImportResult.isFailed,
                        assetsInFile: model.cloud.lastImportResult.assetsInFile
                            ? {
                                frames: model.cloud.lastImportResult.assetsInFile.frames,
                                components: model.cloud.lastImportResult.assetsInFile.components,
                            }
                            : null,
                        invalidReferencesCount: (_1 = model.cloud.lastImportResult.invalidReferencesCount) !== null && _1 !== void 0 ? _1 : null,
                    }
                    : null,
            };
        }
        else {
            this.cloud = null;
        }
        if (model.tokenStudio) {
            this.tokenStudio = {
                connectionName: model.tokenStudio.connectionName,
                lastImportedAt: model.tokenStudio.lastImportedAt
                    ? new Date(model.tokenStudio.lastImportedAt)
                    : undefined,
                settings: model.tokenStudio.settings,
                lastImportedResults: model.tokenStudio.lastImportedResults,
            };
        }
        if (model.figmaVariablesPlugin) {
            this.figmaVariablesPlugin = {
                fileId: model.figmaVariablesPlugin.fileId,
                lastImportedAt: model.figmaVariablesPlugin.lastImportedAt
                    ? new Date(model.figmaVariablesPlugin.lastImportedAt)
                    : undefined,
                lastImportMetadata: model.figmaVariablesPlugin.lastImportMetadata,
                isTokenTypeSplitEnabled: model.figmaVariablesPlugin.isTokenTypeSplitEnabled,
            };
        }
        if (model.storybook) {
            this.storybook = {
                userUrl: model.storybook.userUrl,
                indexUrl: model.storybook.indexUrl,
                isFailed: model.storybook.isFailed,
                docsCount: model.storybook.docsCount,
                storiesCount: model.storybook.storiesCount,
                lastImportedAt: model.storybook.lastImportedAt
                    ? new Date(model.storybook.lastImportedAt)
                    : undefined,
                lastImportedSuccessfully: model.storybook.lastImportedSuccessfully
                    ? new Date(model.storybook.lastImportedSuccessfully)
                    : undefined,
                description: model.storybook.description,
                isUsingVpn: model.storybook.isUsingVpn,
                lastImportedResult: model.storybook.lastImportedResult,
                isCLI: model.storybook.description === STORYBOOK_CLI_IMPORT_DESCRIPTION,
            };
        }
        this.scope = model.scope;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        var _a, _b, _c;
        return {
            type: sourceRemoteTypeFromLocal(this.type),
            id: this.id,
            fileName: (_a = this.fileName) !== null && _a !== void 0 ? _a : undefined,
            brandId: (_b = this.brandId) !== null && _b !== void 0 ? _b : undefined,
            themeId: (_c = this.themeId) !== null && _c !== void 0 ? _c : undefined,
            cloud: this.cloud
                ? {
                    fileId: this.cloud.fileId,
                    autoImportMode: this.cloud.autoImportMode,
                    fileThumbnailUrl: this.cloud.fileThumbnailUrl,
                    lastUpdatesCheckedAt: this.cloud.lastUpdatesCheckedAt
                        ? this.cloud.lastUpdatesCheckedAt.toISOString()
                        : undefined,
                    lastImportedAt: this.cloud.lastImportedAt
                        ? this.cloud.lastImportedAt.toISOString()
                        : undefined,
                    lastImportedVersion: this.cloud.lastImportedVersion,
                    lastImportResult: this.cloud.lastImportResult,
                    ownerId: this.cloud.ownerId,
                    ownerUserName: this.cloud.ownerUserName,
                    state: this.cloud.state,
                    stats: this.cloud.stats,
                }
                : undefined,
            scope: this.scope,
        };
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using `fromTransport` */
    toTransport() {
        return {
            type: this.type,
            id: this.id,
            fileName: this.fileName,
            cloud: this.cloud
                ? {
                    fileId: this.cloud.fileId,
                    autoImportMode: this.cloud.autoImportMode,
                    fileThumbnailUrl: this.cloud.fileThumbnailUrl,
                    lastUpdatesCheckedAt: this.cloud.lastUpdatesCheckedAt
                        ? this.cloud.lastUpdatesCheckedAt.toISOString()
                        : undefined,
                    lastImportedAt: this.cloud.lastImportedAt
                        ? this.cloud.lastImportedAt.toISOString()
                        : undefined,
                    lastImportedVersion: this.cloud.lastImportedVersion,
                    lastImportResult: this.cloud.lastImportResult,
                    ownerId: this.cloud.ownerId,
                    ownerUserName: this.cloud.ownerUserName,
                    state: this.cloud.state,
                    stats: this.cloud.stats,
                }
                : null,
            brandId: this.brandId,
            themeId: this.themeId,
            scope: this.scope,
        };
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        var _a, _b, _c;
        return {
            type: sourceRemoteTypeFromLocal(model.type),
            id: model.id,
            fileName: (_a = model.fileName) !== null && _a !== void 0 ? _a : undefined,
            brandId: (_b = model.brandId) !== null && _b !== void 0 ? _b : undefined,
            themeId: (_c = model.themeId) !== null && _c !== void 0 ? _c : undefined,
            scope: model.scope,
            // @ts-expect-error TS(2322): Type '{ lastUpdatesCheckedAt: string | undefined; ... Remove this comment to see the full error message
            cloud: Object.assign(Object.assign({}, model.cloud), { 
                // @ts-expect-error TS(2533): Object is possibly 'null' or 'undefined'.
                lastUpdatesCheckedAt: model.cloud.lastUpdatesCheckedAt, 
                // @ts-expect-error TS(2533): Object is possibly 'null' or 'undefined'.
                lastImportedAt: model.cloud.lastImportedAt }),
        };
    }
}
function sourceTypeFromRemote(remoteType) {
    switch (remoteType) {
        case SourceRemoteType.figma:
            return SourceType.figma;
        case SourceRemoteType.tokenStudio:
            return SourceType.tokenStudio;
        case SourceRemoteType.figmaVariablesPlugin:
        case SourceRemoteType.upload:
            return SourceType.figmaVariablesPlugin;
        case SourceRemoteType.storybook:
            return SourceType.storybook;
        default:
            return SourceType.figma;
    }
}
function sourceRemoteTypeFromLocal(remoteType) {
    switch (remoteType) {
        case SourceType.figma:
            return SourceRemoteType.figma;
        case SourceType.tokenStudio:
            return SourceRemoteType.tokenStudio;
        case SourceType.figmaVariablesPlugin:
            return SourceRemoteType.figmaVariablesPlugin;
        default:
            return SourceRemoteType.figma;
    }
}
